import axios from '@/utils/axios'
import * as types from '../mutation-types'

// state
export const state = {
  user: null,
  users: [],
  plans: []
};

// getters
export const getters = {
  user: state => state.user,
  users: state => state.users,
  plans: state => state.plans,
};

// mutations
export const mutations = {

  [types.FETCH_USERS_SUCCESS](state, {users}) {
    console.log("users", users);
    state.users = users;
  },

  [types.UPDATE_PLANS](state, plans) {
    state.plans = plans;
  },


};

// actions
export const actions = {

  async fetchUsers({commit}) {
    try {
      const {data} = await axios.get('/admin/users');

      commit(types.FETCH_USERS_SUCCESS, {users: data})
    } catch (e) {
      commit(types.FETCH_USERS_FAILURE)
    }
  },

  updatePlans({commit}, data) {
    commit(types.UPDATE_PLANS, data)
  }
};
